import React, { useEffect, useState, useRef, useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { Modal } from 'antd';

import ComplexDocumentDesign from './index';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import { FullPageLoaderContainer } from '../../artboard/styles';
import Loader from '../../components/Loader';

import { CONTEXT_KEYS } from '../../context/complexArtboardContext';

import { getMasterDocument } from '../../utils/services/complexDocumentsAPI';
import { getIndexedDBData, putIndexedDBData } from '../../utils/indexedDBUtil';
import SessionContext from '../../context/sessionContext';

import loginError from '../../images/loginError.png';

const OVERRIDE_ARTBOARD_STATE = { [CONTEXT_KEYS.IS_OPEN_DESIGN]: true };

const OpenDesign = () => {
  const { documentId: masterTemplateId } = useParams();
  const [ showDesign, setShowDesign ] = useState(false);
  const [ invalidDesign, setInvalidDesign ] = useState(false);
  const masterVariablesRef = useRef(undefined);

  const history = useHistory();

  useEffect(() => {
    const importMasterTemplate = async () => {
      const design = await getIndexedDBData('masterDocument');
      if (design && design?.id === masterTemplateId) {
        masterVariablesRef.current = design?.variables;
        setShowDesign(true);
        return;
      }
      const payload = { draftDocumentId: masterTemplateId }
      const masterTemplateResponse = await getMasterDocument(payload, true);


      if (masterTemplateResponse.data[0]) {
        putIndexedDBData('masterDocument', Object.assign({}, masterTemplateResponse.data[0]));
        putIndexedDBData('openDocument', Object.assign({}, masterTemplateResponse.data[0]?.documentDTO));
        masterVariablesRef.current = masterTemplateResponse.data[0]?.variables;
        setShowDesign(true);
      } else {
        setInvalidDesign(true);
      }
    }
    if (masterTemplateId) {
      importMasterTemplate();
    }
  }, [masterTemplateId]);

  if (showDesign) {
    return (
      <ComplexDocumentDesign isOpenDesign={true} customState={OVERRIDE_ARTBOARD_STATE} masterVariables={masterVariablesRef.current} />
    );
  } else if (invalidDesign) {
    return (
        <Modal
          closable={false}
          footer={null}
          visible={true}
          okButtonProps={{ style: { display: 'none' } }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', marginBottom: '14px', marginTop: '20px' }}>
            <img style={{ width: '50%', height: '50%', display: 'flex', justifyContent: 'space-between' }} src={loginError} alt="blank-canvas" />
              <div><p style={{ fontSize: '18px' }}> This template is not available for design. </p></div>
          </div>
        </Modal>
    )
  }

  return (
    <FullPageLoaderContainer>
      <Loader fullpage="true" />
    </FullPageLoaderContainer>
  );
}

export default OpenDesign;